import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { routesFrontend } from "../RouterFiles/routes";
import { useNavigate } from "react-router";

const Footer = () => {
  const { t } = useTranslation();
  const routes = [routesFrontend.home, routesFrontend.worldOfEports, routesFrontend.profile, routesFrontend.rewards, routesFrontend.more]

  const [active, setActive] = useState(0);
  const [pagePath, setPagePath] = useState("");
  const navigate = useNavigate()
  const handlerIcons = (e) => {
    e.stopPropagation()
    let data = e.target.dataset.target
    if (data == "allGames") {
      setActive(0)
      navigate(routes[0])
    }
    if (data == "worldOfEsports") {
      setActive(1)
      navigate(routes[1])
    }

  }
  const handlerActive = (index) => {
    // setActive(index)
    navigate(routes[index])
  }
  useEffect(() => {
    setPagePath("");
    const path = window.location.pathname
    const segments = path.split('/'); // Split the path into segments
    const keyword = "/"+segments[1];

    if (keyword == routes[0]) {
      setActive(0)
      setPagePath(routes[0]);
    }
    if (keyword == routes[1]) {
      setActive(1)
      setPagePath(routes[1]);
    }
    if (keyword == routes[2]) {
      setActive(2)
      setPagePath(routes[2]);
    }
    if (keyword == routes[3]) {
      setActive(3)
      setPagePath(routes[3]);
    }
    if (keyword == routes[4]) {
      setActive(4)
      setPagePath(routes[4]);
    }
  }, [])
  return (
    <div className="footer d-flex justify-content-around"
    // onClick={(e) => handlerIcons(e)}
    >
      <div className={`footer-icons ${(active == 0 && pagePath) && "active"}`} data-target="allGames" data-index-number="0" onClick={() => handlerActive(0)}>
        <span data-index-number="0">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.0195 9.32812H8.94093C5.71513 9.32812 3.1001 11.9408 3.1001 15.1638C3.1001 18.3867 5.71513 20.9995 8.94093 20.9995H15.0195C18.2453 20.9995 20.8604 18.3867 20.8604 15.1638C20.8604 11.9408 18.2453 9.32812 15.0195 9.32812Z"
              stroke={(active == 0 && pagePath) ? "var(--color-yellow)" : "var(--color-svg)"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8.87891 13.0088V17.3196" stroke={(active == 0 && pagePath) ? "var(--color-yellow)" : "var(--color-svg)"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11.0394 15.1689H6.72852" stroke={(active == 0 && pagePath) ? "var(--color-yellow)" : "var(--color-svg)"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M14.8027 18.3289C15.5909 18.3289 16.2298 17.69 16.2298 16.9018C16.2298 16.1136 15.5909 15.4746 14.8027 15.4746C14.0145 15.4746 13.3755 16.1136 13.3755 16.9018C13.3755 17.69 14.0145 18.3289 14.8027 18.3289Z"
              fill={(active == 0 && pagePath) ? "var(--color-yellow)" : "var(--color-svg)"} />
            <path d="M16.8705 15.2274C17.6587 15.2274 18.2977 14.5884 18.2977 13.8002C18.2977 13.012 17.6587 12.373 16.8705 12.373C16.0823 12.373 15.4434 13.012 15.4434 13.8002C15.4434 14.5884 16.0823 15.2274 16.8705 15.2274Z"
              fill={(active == 0 && pagePath) ? "var(--color-yellow)" : "var(--color-svg)"} />
            <path d="M11.9801 9.32831L12.601 7.77604C12.9308 6.95149 12.4014 6.03579 11.5222 5.9102V5.9102C10.4042 5.75047 9.94828 4.38285 10.7469 3.58422L11.3458 2.98535"
              stroke={(active == 0 && pagePath) ? "var(--color-yellow)" : "var(--color-svg)"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span >
        <span data-index-number="0" className={`${(active == 0 && pagePath) && "activeBorder"}`}>{t("allGames")}</span>
      </div>
      <div className={`footer-icons ${(active == 1 && pagePath) && "active"}`} data-target="worldOfEsports" onClick={() => handlerActive(1)}>
        <span>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
              stroke={(active == 1 && pagePath) ? "var(--color-yellow)" : "var(--color-svg)"} stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12.0001 21C13.9045 21 15.4484 16.9706 15.4484 12C15.4484 7.02944 13.9045 3 12.0001 3C10.0956 3 8.55176 7.02944 8.55176 12C8.55176 16.9706 10.0956 21 12.0001 21Z"
              stroke={(active == 1 && pagePath) ? "var(--color-yellow)" : "var(--color-svg)"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12 15.4484C16.9706 15.4484 21 13.9045 21 12.0001C21 10.0956 16.9706 8.55176 12 8.55176C7.02944 8.55176 3 10.0956 3 12.0001C3 13.9045 7.02944 15.4484 12 15.4484Z"
              stroke={(active == 1 && pagePath) ? "var(--color-yellow)" : "var(--color-svg)"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
        <span className={`${(active == 1 && pagePath) && "activeBorder"}`}>{t("worldOfEsports")}</span>
      </div>
      <div className={`footer-icons ${(active == 2 && pagePath) && "active"}`} data-target="profile" onClick={() => handlerActive(2)}>
        <span>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M20.9997 12.0196C21.0048 13.9565 20.3771 15.8423 19.2118 17.3913C18.3751 18.5123 17.2871 19.4224 16.0349 20.0488C14.7827 20.6753 13.4009 21.0008 12.0001 20.9992C10.5993 20.9949 9.21859 20.6659 7.96704 20.038C6.71549 19.4101 5.6273 18.5007 4.78836 17.3813C3.62512 15.835 2.99759 13.9531 3.0005 12.0196C3.0005 9.62748 3.95291 7.33331 5.64819 5.6418C7.34347 3.95029 9.64278 3 12.0403 3C14.4238 3.02114 16.7025 3.98076 18.3805 5.66998C20.0584 7.35921 20.9998 9.64131 20.9997 12.0196V12.0196Z"
              stroke={(active == 2 && pagePath) ? "var(--color-yellow)" : "var(--color-svg)"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11.96 11.7862C13.5465 11.7862 14.8327 10.5029 14.8327 8.91994C14.8327 7.33696 13.5465 6.05371 11.96 6.05371C10.3735 6.05371 9.0874 7.33696 9.0874 8.91994C9.0874 10.5029 10.3735 11.7862 11.96 11.7862Z"
              stroke={(active == 2 && pagePath) ? "var(--color-yellow)" : "var(--color-svg)"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M19.1715 17.3915C18.3347 18.5125 17.2468 19.4226 15.9945 20.049C14.7423 20.6755 13.3606 21.0009 11.9598 20.9994C10.5589 20.9951 9.17825 20.666 7.9267 20.0382C6.67515 19.4103 5.58699 18.5008 4.74805 17.3815C5.1141 16.3418 5.79292 15.4402 6.69178 14.7998C7.59063 14.1595 8.6657 13.8116 9.77013 13.8037H14.069C15.4922 13.8027 16.8576 14.3649 17.8657 15.3671C18.4557 15.9291 18.9033 16.6229 19.1715 17.3915V17.3915Z"
              stroke={(active == 2 && pagePath) ? "var(--color-yellow)" : "var(--color-svg)"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
        <span className={`${(active == 2 && pagePath) && "activeBorder"}`}>{t("profile.profile")}</span>
      </div>
      <div className={`footer-icons ${(active == 3 && pagePath) && "active"}`} data-target="rewards" onClick={() => handlerActive(3)}>
        <span>

          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M10.0142 3.37988C11.1415 3.37988 12.064 4.29497 12.064 5.42969V7.47949H10.0142C8.88677 7.47949 7.96436 6.5644 7.96436 5.42969C7.96436 4.30229 8.87945 3.37988 10.0142 3.37988Z"
              stroke={(active == 3 && pagePath) ? "var(--color-yellow)" : "var(--color-svg)"} stroke-width="2" stroke-miterlimit="10" />
            <path d="M14.1138 7.47949L12.064 7.47949V5.42969C12.064 4.3023 12.9791 3.37989 14.1138 3.37989C15.2412 3.37989 16.1636 4.29498 16.1636 5.42969C16.1636 6.55708 15.2485 7.47949 14.1138 7.47949Z"
              stroke={(active == 3 && pagePath) ? "var(--color-yellow)" : "var(--color-svg)"} stroke-width="2" stroke-miterlimit="10" />
            <path d="M17.9425 8.21191H6.04634C4.86575 8.21191 3.90869 9.16897 3.90869 10.3496C3.90869 11.5302 4.86575 12.4872 6.04634 12.4872H17.9425C19.1231 12.4872 20.0802 11.5302 20.0802 10.3496C20.0802 9.16897 19.1231 8.21191 17.9425 8.21191Z"
              stroke={(active == 3 && pagePath) ? "var(--color-yellow)" : "var(--color-svg)"} stroke-width="2" stroke-miterlimit="10" />
            <path d="M6.04639 12.4941H18.0743V19.156C18.0743 19.9613 17.4155 20.6201 16.6102 20.6201H7.51053C6.70525 20.6201 6.04639 19.9613 6.04639 19.156V12.4941Z"
              stroke={(active == 3 && pagePath) ? "var(--color-yellow)" : "var(--color-svg)"} stroke-width="2" stroke-miterlimit="10" />
          </svg>


        </span>
        <span className={`${(active == 3 && pagePath) && "activeBorder"}`}>{t("rewards")}</span>
      </div>
      <div className={`footer-icons ${(active == 4 && pagePath) && "active"}`} data-target="more" onClick={() => handlerActive(4)}>
        <span>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.25198 14.5196C5.50002 14.5196 6.51176 13.5078 6.51176 12.2598C6.51176 11.0117 5.50002 10 4.25198 10C3.00393 10 1.99219 11.0117 1.99219 12.2598C1.99219 13.5078 3.00393 14.5196 4.25198 14.5196Z"
              fill={(active == 4 && pagePath) ? "var(--color-yellow)" : "var(--color-svg)"} />
            <path d="M12 14.5196C13.2481 14.5196 14.2598 13.5078 14.2598 12.2598C14.2598 11.0117 13.2481 10 12 10C10.752 10 9.74023 11.0117 9.74023 12.2598C9.74023 13.5078 10.752 14.5196 12 14.5196Z"
              fill={(active == 4 && pagePath) ? "var(--color-yellow)" : "var(--color-svg)"} />
            <path d="M19.7476 14.5196C20.9956 14.5196 22.0074 13.5078 22.0074 12.2598C22.0074 11.0117 20.9956 10 19.7476 10C18.4995 10 17.4878 11.0117 17.4878 12.2598C17.4878 13.5078 18.4995 14.5196 19.7476 14.5196Z"
              fill={(active == 4 && pagePath) ? "var(--color-yellow)" : "var(--color-svg)"} />
          </svg>


        </span>
        <span className={`${(active == 4 && pagePath) && "activeBorder"}`}>{t("moreMenu.title_more")}</span>
      </div>
    </div>
  );
};

export default Footer;
